export default __webpack_public_path__ + "static/confetti-0f9eab9b22b390e18bf9b433aedc27c2.gif";